module.exports = __webpack_public_path__ + "assets/6f56c7511ea7aa9961efda97a94d8c84.mp3";